/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import ReactMarkdown from "react-markdown";
import styled from "styled-components";

import { Message } from "@vienna/common";

import { Color } from "src/app/themes";

interface Props {
  messages: Message[];
}
export function Messages({ messages }: Props) {
  return (
    <MessagesWrapper>
      {messages.map((message, index) => (
        <MessageWrapper key={index}>
          <MessageRole>{message.role}</MessageRole>
          <MessageContent>
            <ReactMarkdown>{message.text}</ReactMarkdown>
          </MessageContent>
        </MessageWrapper>
      ))}
    </MessagesWrapper>
  );
}
const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 50px;
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${Color.Gray3};
  background-color: ${Color.Gray1};
  margin: 20px 0;
  padding: 20px;
`;

const MessageRole = styled.div`
  font-weight: bold;
  padding: 10px 0;
`;
const MessageContent = styled.div``;
